import styled from "styled-components";
import { Link as ReactRouterLink } from "react-router-dom";

export const Link = styled(ReactRouterLink)``;

export const Card = styled(Link)`
  background-color: white;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
`;


export const Title = styled("h3")`
  width: 100%;
  margin: 0px;
  font-size: 14px;
  font-weight: 500;
`;

export const Progress = styled("div")``;
